import styled from 'styled-components';

export const Separator = styled.div`
    padding: 16px;
    font-size: 12px;
    color: #6b6b6b;
    text-transform: uppercase;
`;
